<template>
  <div>
    <section>
      <div class="flex-between">
        <h2 class="inner-headers">&nbsp;</h2>

        <div style="padding: 24px 30px 10px 10px;">
          <button class="second" @click="openedFilters = true"><i class="el-icon-s-operation" /> Filters</button>
        </div>
      </div>
    </section>
    <applied-filters :filters="appliedFilters" @clear="clearFilters()" @remove="removeFilter($event)" />

    <section  class="content-tlist">
        <table class="content-table">
          <tr>
            <th v-for="(item, i) in header">{{ item }}</th>
            <th>Options</th>
          </tr>
          <tr v-for="registration in registrations" :key="registration.id">
            <td v-for="(item, i) in registration" :key="i">
              <template v-if="i == 'data'">
                <textarea cols="40" v-model="itemData" rows="10" v-if="isEdit(registration.id)">
                </textarea>
                <template v-else>
                  {{ item }}
                </template>
              </template>
              <template v-if="i == 'createdBy'">
                <template v-if="item">{{item.id}}</template>
              </template>
              <template v-else>{{ item }}</template>
            </td>
            <td><span>Options</span>
              <template v-if="isEdit(registration.id)">
                <button @click="saveUpdate(registration)" class="action-button save">Save</button>
                <button @click="cancelEdit(registration.id)" class="action-button cancel">Cancel</button>
              </template>
              <template v-else-if="!editStatus">
                <button @click="edit(registration)" class="action-button update">Edit</button>
              </template>
            </td>
          </tr>
        </table>
      </section>
    <section class="pagination-section">
      <div>
        Per page
        <select v-model="perPage" @change="setPages()">
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="75">75</option>
          <option value="100">100</option>
          <option value="150">150</option>
          <option value="200">200</option>
        </select>
      </div>
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item">
            <button type="button" class="page-link" v-if="page != 1" @click="page--"> Previous </button>
          </li>
          <li class="page-item">
            <button type="button" class="page-link" v-for="pageNumber in pages.slice(page-1, page+5)" :key="pageNumber" @click="page = pageNumber"> {{pageNumber}} </button>
          </li>
          <li class="page-item">
            <button type="button" @click="page++" v-if="page < pages.length" class="page-link"> Next </button>
          </li>
        </ul>
      </nav>
    </section>

    <profile-filters v-if="openedFilters" :filters="filters" @apply="applyFilters($event)" @close="openedFilters = false" />
  </div>
</template>

<script>
  import VueEnglishdatepicker from 'vue-englishdatepicker';
  import DateTimePicker from 'vue-vanilla-datetime-picker';
  import ProfileFilters from './filters/ProfileFilters'
  import AppliedFilters from '../../components/common/AppliedFilters'

  export default {
    components: {
      VueEnglishdatepicker,
      DateTimePicker,
      ProfileFilters,
      AppliedFilters
    },

    data: () => ({
      openedFilters: false,
      filters: null,
      activeInfo: false,
      page: 1,
      perPage: 25,
      pages: [],
      totalNumber: 0,
      editing: [],
      itemData: null,
      editStatus: false
    }),

    computed: {
      profileStatuses () {
        return window.profileStatuses
      },

      appliedFilters () {
        const filterNames = {
          profileId: 'Profile ID',
          name: 'Name',
          type: 'Profile Type',
          status: 'Status'
        }

        if (!this.filters) return []

        let appliedFilters = Object.keys(this.filters).filter(key => ![null, ''].includes(this.filters[key]))
        const hasDateFilters = appliedFilters.includes('fromDate') || appliedFilters.includes('toDate')
        appliedFilters = appliedFilters.filter(key => key !== 'fromDate' && key !== 'toDate').map(key => ({
          key,
          text: `${filterNames[key]}: ${this.getFilterValue(key, this.filters[key])}`
        }))

        if (hasDateFilters) {
          appliedFilters.push({
            key: 'date',
            text: `Date Range: ${this.getDateText()}`
          })
        }

        return appliedFilters
      },

      profileStatusesWithoutComplete () {
        const array = ['Complete', 'Active', 'Review', 'Restricted', 'Hold', 'Dormant', 'Closed']
        array.splice(0, 1)
        return array
      },

      registrations () {
        let registrations = this.$store.state.registrations.data || []
        this.totalNumber = this.$store.state.registrations.count || 0

        if (!this.filters || !Object.values(this.filters).filter(val => val).length) {

        }
        if (this.filters) {
          if (this.filters.name) {
            registrations = registrations.filter(reg => {
              const name = reg.type === 'Personal' ? `${reg.data.firstName} ${reg.data.lastName}` : reg.data.legal_name
              return name.toLowerCase().includes(this.filters.name.toLowerCase())
            })
          }

          if (this.filters.fromDate) {
            const from = moment(this.filters.fromDate, 'YYYY-MM-DD')
            registrations = registrations.filter(reg => {
              if (!reg.approvalDate) return true
              const date = moment(reg.approvalDate.split(' ')[0], 'YYYY-MM-DD')
              return date >= from
            })
          }

          if (this.filters.toDate) {
            const to = moment(this.filters.toDate, 'YYYY-MM-DD')
            registrations = registrations.filter(reg => {
              if (!reg.approvalDate) return true
              const date = moment(reg.approvalDate.split(' ')[0], 'YYYY-MM-DD')
              return date <= to
            })
          }

          if (this.filters ?.status) {
            if(this.filters.status == 'Complete') {
              registrations = registrations.filter(reg => reg.status === 'Complete' || reg.status === 'Activation')
            }else{
              registrations = registrations.filter(reg => reg.status === this.filters.status)
            }
          }

          if (this.filters.profileId) {
            registrations = registrations.filter(reg =>{
                return reg.profileNumber?.includes(this.filters.profileId)
              }
            )
          }

          if (this.filters.type) {
            registrations = registrations.filter(reg => reg.type === this.filters.type)
          }
          this.totalNumber = registrations.length
        }

        return registrations
      },

      header () {
        let header = []
        if(this.registrations.length > 0) {
          header = Object.keys(this.registrations[0])
        }
        return header
      },

      statusColorClasses () {
        return {
          Active: 'c1',
          Restricted: 'c2',
          Complete: 'c2',
          Activation: 'c2',
          Suspended: 'c2',
          Dormant: 'c3',
          Closed: 'c1'
        }
      }
    },

    async created () {
      await this.refreshRegistrations();
    },

    methods: {
      isEdit (index) {
        return this.editing.includes(index)
      },

      edit(registration) {
        this.editStatus = true
        this.itemData = JSON.stringify(registration.data)
        this.editing.push(registration.id)
      },

      cancelEdit (i) {
        const index = this.editing.indexOf(i)
        this.editing.splice(index, 1)
        this.editStatus = false
      },

      getDateText () {
        const from = this.filters.fromDate
        const to = this.filters.toDate

        let text = ''
        if (from) text = `From ${moment(from).format('LL')} `
        if (to) text += `To ${moment(to).format('LL')}`
        return text
      },

      getFilterValue (key, value) {
        if (key === 'status') return window.customerProfileStatuses[value]

        return value
      },

      clearFilters () {
        this.filters = null
      },

      removeFilter (filter) {
        if (filter.key === 'date') {
          this.$delete(this.filters, 'fromDate')
          this.$delete(this.filters, 'toDate')
          return;
        }

        this.$delete(this.filters, filter.key)
      },

      applyFilters (filters) {
        this.filters = filters
        this.openedFilters = false
      },

      async refreshRegistrations () {
        const loader = this.$loading.show()
        this.loading=true;
        let params = {}
        params.corporate = ['!=',  1];
        if (!this.filters || !Object.values(this.filters).filter(val => val).length) {

        } else {
          if (this.filters.fromDate)
            params.createdAtAfter=[">=", this.filters.fromDate+" 00:00:00", "approvalDate"];
          if (this.filters.toDate)
            params.createdAtBefore=["<=", this.filters.toDate+" 23:59:59", "approvalDate"];

          if (this.filters.name) { 
            params.data = ['like', '%' + this.filters.name + '%'];
          } 

          if (this.filters.status) { 
            params.status = ['like', '%' + this.filters.status + '%'];
          } 

          if (this.filters.profileId) { 
            params.profileNumber = ['like', '%' + this.filters.profileId + '%'];
          }
          
          if (this.filters.type) { 
            params.type = ['like', '%' + this.filters.type + '%'];
          } 
        }

        await this.$store.dispatch('registrations/load', { order: ['id:DESC'], params, limit: this.perPage, start: (this.page-1) * this.perPage, skip: ['user', 'contact', 'terms', 'serviceProviders', 'complianceScan', 'confirmation', 'documentsChecklist', 'documents', 'primeAccount', 'accounts', 'regId', 'mainAccount', 'profileSettings', 'user', 'isPersonal', 'isMaster', 'setupComplete', 'contact', 'name', 'complianceReview'] })
        this.loading=false;
        loader.hide()
      },

      setPages () {
        let numberOfPages = 0;
        numberOfPages = Math.ceil(this.totalNumber / this.perPage);

        this.pages = [];
        for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
        }
      },

      async paginate (data) {
        let page = this.page;
        let perPage = this.perPage;
        let from = (page * perPage) - perPage;
        let to = (page * perPage);
        return data.slice(from, to);
      },

      async saveUpdate (registration) {
        try {
          const payload = {
            id: registration.id,
            payload: {
              data: JSON.parse(this.itemData)
            }
          }

          await this.$store.dispatch('registrations/update', payload)
          this.refreshRegistrations()
          this.$toast.success('Registration successfully updated.')
          this.cancelEdit(registration.id)
        } catch (e) {
          this.$toast.error(window.errorMessage)
        }
      },

    },

    watch: {
      registrations () {
        this.setPages();
      },

      appliedFilters () {
        this.refreshRegistrations();
      },

      page() {
        this.refreshRegistrations();
      },

      perPage() {
        if(this.page == 1){
          this.refreshRegistrations();
        }else{
          this.page = 1
        }
      }
    },
  }
</script>
<style scoped>
  th {
    padding: 5px;
  }

  .content-tlist {
    overflow: scroll;
    max-width: 1500px;
    max-height: 100vh;
  }

</style>
